import React, {
  useEffect,
  useState,
} from "react";

import {
  FaSave,
  FaTimes,
} from "react-icons/fa";

import {
  toast,
} from "react-toastify";

import Button from "../../../../components/Button/Button";

import {
  createActeur,
  createActeurByUser,
} from "../../../../services/acteursServices";

import {
  EMPTY_ACTEUR,
} from "./../data/acteurAdmin.constants";

import {
  buildActeurPayload,
} from "../utils/acteursAdmin.utils";

import UserLinkSelect from "../ui/UserLinkSelect";

import ActeurFormFields from "./ActeurFormFields";

export default function CreateActeurModal({
  isOpen,
  onClose,
  refreshList,
  users = [],
}) {
  const [
    acteurData,
    setActeurData,
  ] = useState(EMPTY_ACTEUR);

  const [
    selectedUserId,
    setSelectedUserId,
  ] = useState("");

  const [
    isSubmitting,
    setIsSubmitting,
  ] = useState(false);

  useEffect(() => {
    if (!isOpen) {
      setActeurData(EMPTY_ACTEUR);
      setSelectedUserId("");
      setIsSubmitting(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleChange = (event) => {
    const {
      name,
      value,
    } = event.target;

    setActeurData(
      (previousData) => ({
        ...previousData,
        [name]: value,
      }),
    );
  };

  const handleClose = () => {
    if (isSubmitting) return;

    onClose();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (isSubmitting) return;

    try {
      setIsSubmitting(true);

      const payload =
        buildActeurPayload(
          acteurData,
        );

      if (selectedUserId) {
        await createActeurByUser({
          ...payload,

          user_id: Number(
            selectedUserId,
          ),
        });

        toast.success(
          "Acteur créé et lié à l’utilisateur",
        );
      } else {
        await createActeur(payload);

        toast.success(
          "Acteur créé avec succès",
        );
      }

      await refreshList();

      onClose();
    } catch (error) {
      console.error(
        "Erreur lors de la création de l’acteur :",
        error,
      );

      toast.error(
        error?.response?.data?.message ||
          "Erreur lors de la création de l’acteur",
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 px-2 py-3 backdrop-blur-sm">
      <div className="flex max-h-[calc(100vh-24px)] w-full max-w-3xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl dark:bg-slate-900">
        {/* En-tête */}
        <div className="flex shrink-0 items-center justify-between bg-gradient-to-r from-blue-600 via-violet-600 to-pink-500 px-5 py-4">
          <div>
            <h3 className="text-base font-bold uppercase tracking-[0.18em] text-white sm:text-lg">
              Ajouter un acteur
            </h3>

            <p className="mt-1 text-xs text-white/85">
              Créez sa fiche et
              associez-la éventuellement
              à un compte utilisateur.
            </p>
          </div>

          <button
            type="button"
            onClick={handleClose}
            disabled={isSubmitting}
            className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-black/20 text-white transition hover:bg-black/30 disabled:opacity-50"
          >
            <FaTimes />
          </button>
        </div>

        {/* Formulaire */}
        <form
          onSubmit={handleSubmit}
          className="flex min-h-0 flex-1 flex-col"
        >
          <div className="min-h-0 flex-1 space-y-5 overflow-y-auto px-5 py-4 sm:px-6 sm:py-5">
            <ActeurFormFields
              data={acteurData}
              onChange={handleChange}
            />

            <UserLinkSelect
              users={users}
              value={selectedUserId}
              onChange={
                setSelectedUserId
              }
              disabled={
                isSubmitting
              }
            />
          </div>

          {/* Actions */}
          <div className="flex shrink-0 justify-end gap-2 border-t border-slate-200 bg-white px-5 py-4 dark:border-slate-700 dark:bg-slate-900">
            <Button
              text="Annuler"
              icon={FaTimes}
              type="button"
              onClick={handleClose}
              className="btn-ghost gap-2 !px-4 !py-2"
              disabled={isSubmitting}
            />

            <Button
              text={
                isSubmitting
                  ? "Enregistrement..."
                  : "Créer"
              }
              icon={FaSave}
              type="submit"
              className="btn-primary gap-2 !px-4 !py-2"
              disabled={isSubmitting}
            />
          </div>
        </form>
      </div>
    </div>
  );
}